import { HomePriceIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

export const APP_CONFIG_LISTINGS_MANAGER: AppConfig = {
  name: 'Listings Dashboard',
  applicationKey: 'agent-listings',
  type: 'product',
  globalHeaderTitle: 'Listings Dashboard',
  appSlugForEngagement: AppSlugs.ListingsDashboard,
  rootPath: '/listings-dashboard',
  Icon: HomePriceIcon,
  descriptionLong:
    'View all your listings in one place - and you decide where they go.',
  descriptionShort:
    'View all your listings in one place - and you decide where they go.',
  comingSoon: false,
  hideIfNoAccess: true,
};
